var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app","data-server-rendered":"true"}},[_c('loader',{attrs:{"id":"global"}}),_vm._v(" "),_c('alert'),_vm._v(" "),_c('transition-page',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }